// Polyfill for AbortSignal.timeout for older browsers (Safari < 15.4)
if (!AbortSignal.timeout) {
  AbortSignal.timeout = function(ms) {
    const controller = new AbortController();
    setTimeout(() => controller.abort(), ms);
    return controller.signal;
  };
}

    document.addEventListener('DOMContentLoaded', () => {
  // Select all custom video players on the page
  const videoPlayers = document.querySelectorAll('.custom-video-player');

  videoPlayers.forEach(player => {
    // Get the video and play button elements inside each video player
    const video = player.querySelector('video');
    const playButton = player.querySelector('.custom-play-button');

    // Add click event listener to the play button
    playButton.addEventListener('click', () => {
      // Play the video
      video.play();

      // Hide the play button
      playButton.style.display = 'none';

      // Add controls to the video dynamically
      video.setAttribute('controls', true);
    });

    // Optional: Add an event listener to pause the video when it ends
    video.addEventListener('ended', () => {
      // Show the play button when the video ends
      playButton.style.display = 'block';

      // Remove controls after video ends (optional)
      video.removeAttribute('controls');
    });
  });
});




(function() {
    if (window.location.search.includes("cart-drawer-open")) {
        let miniCart = document.getElementById("mini-cart");
        
        if (miniCart) {
            miniCart.open = true; // Open immediately if found
        } else {
            // If not found yet, retry when DOM is ready
            document.addEventListener("DOMContentLoaded", function() {
                let miniCartLoaded = document.getElementById("mini-cart");
                if (miniCartLoaded) {
                    miniCartLoaded.open = true;
                }
            });
        }
    }
})();



/* vehicle database  */

document.addEventListener("click", function (e) {
  if (e.target.closest(".product-item-database a")) {
    e.preventDefault();
    const productItem = e.target.closest(".product-item-database");
    if (productItem) {
      const popupLayer = productItem.querySelector(".product-item-database-popup-layer");
      const popup = productItem.querySelector(".product-item-database-popup");
      if (popupLayer && popup) {
        popupLayer.classList.add("active");
        popup.classList.add("active");
      }
    }
  }


  if (
    e.target.closest(".product-item-database-popup-close") ||
    e.target.classList.contains("product-item-database-popup-layer")
  ) {
    document.querySelectorAll(".product-item-database-popup-layer.active, .product-item-database-popup.active")
      .forEach(el => el.classList.remove("active"));
  }
  
  
  if (e.target.closest('.add-in-garage')) {
    e.preventDefault();
    const button = e.target.closest('.add-in-garage');
    const productHandle = button.dataset.productHandle;
    addToGarage(productHandle);
  }
  

  if (e.target.closest('.remove-from-garage')) {
    e.preventDefault();
    const button = e.target.closest('.remove-from-garage');
    const productHandle = button.dataset.productHandle;
    removeFromGarage(productHandle);
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.querySelector('#section-garage-search');
  if (searchInput) {
    searchInput.addEventListener('input', debounce(function() {
      filterGarageItems();
      updateItemCounterAfterFilter(); 
    }, 300));
  }

  const sortSelect = document.querySelector('.section-garage-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      sortGarageItems(this.value);
    });
  }

  if (document.querySelector('#garage_items')) {
    loadGarageItems();
  }
});

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function filterGarageItems() {
  const searchTerm = document.querySelector('#section-garage-search').value.toLowerCase().trim();
  const productItems = document.querySelectorAll('.product-item-database');
  
  if (searchTerm === '') {
    productItems.forEach(item => {
      item.style.display = '';
    });
    return;
  }

  productItems.forEach(item => {
    const titleElement = item.querySelector('.product-item-meta__title');
    const title = titleElement ? titleElement.textContent.toLowerCase() : '';
    
    if (title.includes(searchTerm)) {
      item.style.display = '';
    } else {
      item.style.display = 'none';
    }
  });
}

function updateItemCounterAfterFilter() {
  const visibleItems = document.querySelectorAll('.product-item-database:not([style*="display: none"])').length;
  updateItemCounter(visibleItems);
}

function sortGarageItems(order = 'desc') {
  const container = document.querySelector('#garage_items');
  const productItems = Array.from(document.querySelectorAll('.product-item-database'));
  
  productItems.sort((a, b) => {
    const yearA = getYearFromElement(a);
    const yearB = getYearFromElement(b);
    
    if (order === 'asc') {
      return yearA - yearB;
    } else {
      return yearB - yearA;
    }
  });

  container.innerHTML = '';
  productItems.forEach(item => {
    container.appendChild(item);
  });
  
  updateItemCounter(productItems.length);
}

function getYearFromElement(element) {
  const yearElement = element.querySelector('.label-year_of_publication');
  if (!yearElement) return 0;
  
  const yearText = yearElement.textContent.trim();
  const yearMatch = yearText.match(/\d{4}/);
  
  return yearMatch ? parseInt(yearMatch[0]) : 0;
}

function addToGarage(productHandle) {
  let garage = getGarageItems();
  
  if (!garage.includes(productHandle)) {
    garage.push(productHandle);
    saveGarageItems(garage);
    showNotification('Fahrzeug wurde zu deiner Garage hinzugefügt!');
    updateItemCounter(garage.length); 
  } else {
    showNotification('Fahrzeug in die Garage hinzugefügt');
  }
}

function removeFromGarage(productHandle) {
  let garage = getGarageItems();
  garage = garage.filter(item => item !== productHandle);
  saveGarageItems(garage);
  showNotification('Fahrzeug wurde aus deiner Garage entfernt!');
  
  updateItemCounter(garage.length);
  
  if (document.querySelector('#garage_items')) {
    loadGarageItems();
  }
}

async function loadGarageItems() {
  const garageItems = getGarageItems();
  const container = document.querySelector('#garage_items');
  
  updateItemCounter(garageItems.length);
  
  if (garageItems.length === 0) {
    container.innerHTML = '<p>Deine Garage ist leer.</p>';
    return;
  }

  container.innerHTML = '<p>Lade deine Garage-Artikel...</p>';

  try {
    const html = await fetchGarageItems(garageItems);
    container.innerHTML = html || '<p>Deine Garage ist leer.</p>';
    
    const sortSelect = document.querySelector('.section-garage-sort');
    if (sortSelect && container.children.length > 0) {
      sortGarageItems(sortSelect.value);
    }
    
    const loadedItems = container.querySelectorAll('.product-item-database').length;
    updateItemCounter(loadedItems);
    
  } catch (error) {
    console.error('Error loading garage items:', error);
    const loadedItems = container.querySelectorAll('.product-item-database').length;
    if (loadedItems > 0) {
      updateItemCounter(loadedItems);
      container.insertAdjacentHTML('beforeend', '<p style="color: orange; text-align: center; margin-top: 20px;">Einige Fahrzeuge konnten nicht geladen werden.</p>');
    } else {
      container.innerHTML = '<p>Fehler beim Laden der Garage-Artikel. Bitte lade die Seite neu.</p>';
      updateItemCounter(garageItems.length);
    }
  }
}

function updateItemCounter(count) {
  const counterElement = document.querySelector('.section-garage-number-of-items');
  if (counterElement) {
    counterElement.textContent = `${count} Fahrzeuge in der Garage`;
  }
}

async function fetchGarageItems(handles) {
  const BATCH_SIZE = 10;
  const allHtml = [];
  let successCount = 0;
  let failCount = 0;
  
  for (let i = 0; i < handles.length; i += BATCH_SIZE) {
    const batch = handles.slice(i, i + BATCH_SIZE);
    
    const batchResults = await Promise.allSettled(
      batch.map(handle => 
        fetch(`/products/${handle}?view=garage`, {
          signal: AbortSignal.timeout(10000)
        })
          .then(response => {
            if (!response.ok) throw new Error(`Product not found: ${handle}`);
            return response.text();
          })
      )
    );
    
    batchResults.forEach((result, index) => {
      if (result.status === 'fulfilled') {
        allHtml.push(result.value);
        successCount++;
      } else {
        console.warn(`Failed to load product: ${batch[index]}`, result.reason);
        failCount++;
      }
    });
    
    const container = document.querySelector('#garage_items');
    if (container && i === 0) {
      container.innerHTML = allHtml.join('');
    } else if (container) {
      container.insertAdjacentHTML('beforeend', allHtml.slice(-batchResults.filter(r => r.status === 'fulfilled').length).join(''));
    }
    
    updateItemCounter(successCount);
    
    if (i + BATCH_SIZE < handles.length) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }
  }
  
  if (failCount > 0) {
    console.warn(`${failCount} von ${handles.length} Fahrzeugen konnten nicht geladen werden.`);
  }
  
  return allHtml.join('');
}

function getGarageItems() {
  const garageJson = localStorage.getItem('shopify-garage') || '[]';
  return JSON.parse(garageJson);
}

function saveGarageItems(items) {
  localStorage.setItem('shopify-garage', JSON.stringify(items));
}

function showNotification(message, status = "error") {
  const cartNotification = document.querySelector('cart-notification');

  if (cartNotification) {
    cartNotification.dispatchEvent(new CustomEvent("cart-notification:show", {
      bubbles: true,
      cancelable: true,
      detail: { 
        status: status,
        error: message
      }
    }));
  }
  

    cartNotification.classList.remove("cart-notification--error");
    const successSVG = `<svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 24 24" fill="#fff">
      <path d="M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"></path>
    </svg>`;
    
    const existingSvg = cartNotification.querySelector('.icon--cart-notification');
    if (existingSvg) {
      existingSvg.outerHTML = successSVG;
    }
  
}
/* vehicle database  end*/